import getConfig from 'next/config';
import type { NextPageContext } from 'next';
import * as Sentry from '@sentry/nextjs';

import { DefaultLayout } from '../components/Layouts';
import { ErrorPage } from '../components/ErrorPages/ErrorPage';

interface IErrorPageProps {
  statusCode: number | 'default';
  pageVariant?: string;
  disableGtmLog?: boolean;
  domain?: string;
}

function Error({ statusCode, disableGtmLog, domain = '' }: IErrorPageProps) {
  const {
    publicRuntimeConfig: { CDN_STATIC_ASSETS },
  } = getConfig();

  const errorSelector = (statusCode: number | 'default') => {
    switch (statusCode) {
      default:
        return (
          <ErrorPage
            status={statusCode}
            cdnUrl={CDN_STATIC_ASSETS}
            disableGtmLog={disableGtmLog}
          />
        );
    }
  };

  return (
    <DefaultLayout useGenericLogoInHeader domain={domain}>
      {errorSelector(statusCode)}
    </DefaultLayout>
  );
}

Error.getInitialProps = async (contextData: NextPageContext) => {
  // Forwards the error to Sentry (no-op when Sentry isn't initialised). Must run before we return.
  await Sentry.captureUnderscoreErrorException(contextData);

  const { res, err } = contextData;
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
